var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCollapse = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360-360H228q-15.3 0-25.65-10.29Q192-380.58 192-395.79t10.35-25.71Q212.7-432 228-432h168q15.3 0 25.65 10.35Q432-411.3 432-396v168q0 15.3-10.29 25.65Q411.42-192 396.21-192t-25.71-10.35Q360-212.7 360-228v-132Zm240-240h132q15.3 0 25.65 10.29Q768-579.42 768-564.21t-10.35 25.71Q747.3-528 732-528H564q-15.3 0-25.65-10.35Q528-548.7 528-564v-168q0-15.3 10.29-25.65Q548.58-768 563.79-768t25.71 10.35Q600-747.3 600-732v132Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/collapse.f2cf5da6.svg";
export { ForwardRef as ReactComponent };